import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';
import { IEffect } from '../../actions/effects/IEffect';
import { app } from '../../app';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { getMatch2AssetPath } from '../../util/assets';
import { SharpenerBlockEntity } from './SharpenerBlockEntity';

export type SharpenerBlockEffectOptions = {
  entity: SharpenerBlockEntity;
};

export class SharpenerBlockEffect implements IEffect {
  private readonly scene: GameScene;
  private readonly options: SharpenerBlockEffectOptions;
  private readonly entity: SharpenerBlockEntity;

  constructor(scene: GameScene, options: SharpenerBlockEffectOptions) {
    this.scene = scene;
    this.options = options;
    this.entity = options.entity;
  }

  public async execute() {
    //
  }

  public async playShredAnimation() {
    const particles = app.particles.create({
      textures: [
        getMatch2AssetPath('blocks/sharpener/2.png'),
        getMatch2AssetPath('blocks/sharpener/4.png'),
        getMatch2AssetPath('blocks/sharpener/6.png'),
      ],
      rate: 0.05,
      limit: 10,
      emitterDuration: 0.4,
      duration: 1.5,
      velocity: { x: 0, y: -300 },
      scale: [
        { x: 0.8, y: 0.8 },
        { x: 1.1, y: 1.1 },
      ],
      behaviors: [
        { type: 'explode', magnitude: [100, 300], applyRotation: true },
        { type: 'gravity', gravity: { x: 0, y: 1500 } },
        { type: 'fade', to: 0 },
        { type: 'kinematic' },
      ],
    });

    const position = this.entity.c.position.mapPosition.clone();

    if (this.entity.c.block.props.orientation === 'rightToLeft') {
      const width = this.entity.c.blockSharpener.count;
      position.x += width;
    }

    if (this.entity.c.block.props.orientation === 'bottomToTop') {
      const width = this.entity.c.blockSharpener.count;
      position.y += width;
    }

    const overlay = spawnOverlayEntity(
      this.scene,
      position,
      this.entity.c.block.props,
      () => particles.view,
      'foreground',
    );
    await particles.start();
    despawnOverlayEntity(this.scene, overlay);
  }

  public async playDieAnimation() {
    const container = new Container();
    const movieclip = new MovieClip({
      superview: container.view,
      url: getMatch2AssetPath('blocks/sharpener'),
      defaultAnimation: 'sharpener',
    });
    const overlay = spawnOverlayEntity(
      this.scene,
      this.entity.c.position.mapPosition,
      this.entity.c.block.props,
      () => container,
      'foreground',
    );
    await movieclip.playAsync('sharpener_die');
    despawnOverlayEntity(this.scene, overlay);
  }
}
